module.exports = __webpack_public_path__ + "e8ef4bf2d0668a69edfc9a6f9f15c844.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/second_closed.jpg
// module id = 1159
// module chunks = 0